module.exports = __webpack_public_path__ + "c047d39579ba11238d13c70f454c1e46.wav";